import AddTransportVehicleInfoGroupModal from './add-transport-vehicle-info-group-modal.vue'
export default AddTransportVehicleInfoGroupModal
